<template>
  <div>
    <Modal :visible="visible" size="large" @ok="handleOk" @cancel="handleCancel">
      <a-card :bordered="false">
        <div class="content-modal" :class="{collapse: selected}">
          <div class="modal-container">
            <div class="title">
              <p>こだわり条件を指定</p>
            </div>
            <div class="select-price">
              <div class="title">
                <h1>予算（総額）</h1>
              </div>
              <div class="select">
                <a-select
                  class="w-full select-item"
                  placeholder="下限なし"
                  v-model="filterForm.feeLower"
                >
                  <a-select-option value="0">-</a-select-option>
                  <a-select-option
                    v-for="item in filterFormOptions.feeLower"
                    :key="`fee-lower-${item.value}`"
                    :value="item.value"
                  >
                    {{ item.displayName }}
                  </a-select-option>
                </a-select>
                <span class="self-center" style="font-size:10px; align-self: center;">〜</span>
                <a-select
                  class="w-full select-item"
                  placeholder="上限なし"
                  v-model="filterForm.feeUpper"
                >
                  <a-select-option value="0">-</a-select-option>
                  <a-select-option
                    v-for="item in filterFormOptions.feeUpper"
                    :key="`fee-upper-${item.value}`"
                    :value="item.value"
                  >
                    {{ item.displayName }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            <a-divider class="divider-custom" />
            
            <div class="condition-group">
              <h1>部屋タイプ</h1>
              <div class="checkbox-group">
                <a-checkbox-group v-model="filterForm.roomType">
                  <a-row>
                    <a-col :span="12" class="checkbox-ele" v-for="(item, index) in filterFormOptions.roomType" :key="`room-type-${index}`" >
                      <a-checkbox :value="item.value" >
                        {{ item.displayName }}
                        <!-- ({{ item.total || 0 }}） -->
                      </a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </div>
            </div>
            <a-divider class="divider-custom" />

            <div class="condition-group">
              <h1>食事条件</h1>
              <div class="checkbox-group">
                <a-checkbox-group v-model="filterForm.mealCondition">
                  <a-row>
                    <a-col :span="12" class="checkbox-ele" v-for="(item, index) in filterFormOptions.mealCondition" :key="`ceal-cond-${index}`" >
                      <a-checkbox :value="item.value" >
                        {{ item.displayName }}
                        <!-- ({{ item.total || 0 }}） -->
                      </a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </div>
            </div>
            <a-divider class="divider-custom" />

            <div class="condition-group">
              <h1>部屋のこだわり</h1>
              <div class="checkbox-group">
                <a-checkbox-group v-model="filterForm.roomCondition">
                  <a-row>
                    <a-col :span="12" class="checkbox-ele" v-for="(item, index) in filterFormOptions.roomCondition" :key="`room-cond-${index}`" >
                      <a-checkbox :value="item.value" >
                        {{ item.displayName }}
                        <!-- ({{ item.total || 0 }}） -->
                      </a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </div>
            </div>
            <a-divider class="divider-custom" />

            <div class="condition-group">
              <h1>利用方法</h1>
              <div class="checkbox-group">
                <a-checkbox-group v-model="filterForm.usageMethod">
                  <a-row>
                    <a-col :span="12" class="checkbox-ele" v-for="(item, index) in getUsageMethod(filterFormOptions.usageMethod)" :key="`usage-method-${index}`" >
                      <a-checkbox :value="item.value" >
                        {{ item.displayName }}
                        <!-- <span v-if="item.value !== 'canUseCafeteriaPoint' && item.value !== 'canUseSubsidy'">
                          （{{ item.total || 0 }}）
                        </span> -->
                      </a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </div>
            </div>
          </div>
        </div>
        <div class="button">
          <Button @click="handleOk" class="button-item">決定</Button>
          <!-- <Button @click="selected = !selected" class="button-item">絞り込む（000件）</Button> -->
        </div>
      </a-card>
    </Modal>
  </div>
</template>

<script>
import _ from 'lodash'
import cloneDeep from 'lodash/cloneDeep'
import { Button, Modal } from '@/components/primitive'
import filterProperties from '../filterPropertiesMock'
import func_utils from '@/mixins/func_utils'

export default {
  mixins: [func_utils],
  components: {
    Button,
    Modal
  },
  props: ['visible', 'filterForm', 'filterLabelMap'],
  data() {
    return {
      orgFilter: {},
      total: 0,
      rooms: null,
      selected: false,
      priceValue: null,
      evaluateValue: null,
      optionsEvaluate: [
        {
          label: 'すべて 1',
          value: 'すべて 1'
        },
        {
          label: 'すべて 2',
          value: 'すべて 2'
        }
      ],
      status: true,
      filterFormOptions: {},
      searchResult: null,
      excludeKeys: ['numPeople', 'feeUpper', 'feeLower', 'menuNo'],
      filterFormTmp: null,
      isShowCafeteriaPoint: false,
      isShowSupplementaryCoupon: false
    }
  },
  watch: {
    visible() {
      if(this.visible) {
        this.filterFormTmp = _.cloneDeep(this.filterForm)
      }
    }
  },
  created() {
    this.filterFormOptions = _.cloneDeep(filterProperties.data)
    this.filterFormTmp = _.cloneDeep(this.filterForm)
  },
  methods: {
    handleOk() {
      this.filterFormTmp = _.cloneDeep(this.filterForm)
      this.searchPlan()
      this.$emit('ok', {
        filterForm: this.filterForm,
        searchResult: []
      })
    },
    handleCancel() {
      this.$emit('cancel', {
        filterForm: _.cloneDeep(this.filterFormTmp)
      })
    },
    searchPlan() {
      // const { menuNo } = this.$route.params
      // filterFormそのままではなく、filterFormからbodyを作成する
      const body = cloneDeep(this.filterForm)

      // 下限と上限の処理をメニュー一覧に合わせる
      if (this.filterForm.feeLower) {
        body.feeLower = this.filterForm.feeLower
      }
      if (body.feeLower == 0) {
        body.feeLower = 1
      }
      if (this.filterForm.feeUpper) body.feeUpper = this.filterForm.feeUpper
      if (body.feeUpper == 0) {
        body.feeUpper = 100000000; // #72331 で 100 万 → 1 億に変更。本来は上限を外したい意向だったが修正影響があるため上限引き上げの方針になった。
      }

      // this.$repositories('plan').searchPlan(0, 10, menuNo, body).then(
      //   (result) => {
      //     const aggregation = _.get(result, 'aggregation', {})
      //     this.mappingAggregation(aggregation)
      //     this.searchResult = result
      //     this.total = result?.totalItems || 0
      //   }
      // )
    },
    mappingAggregation(data) {
      _.forEach(this.filterFormOptions, (value) => {
        _.forEach(value, (item) => {
          if(item.searchParam === 'roomType') {
            if(_.isEmpty(item?.keys)) {
              item.total = this.formatCurrency(data[item.key], '') || 0
            } else {
              const arr = item.keys.map(a => +this.formatCurrency(data[a], '') || 0)
              item.total = arr.reduce((a, b) => a + b)
            }
            return
          }
          item.total = this.formatCurrency(data[item.value], '') || 0
        })
      })
    },
    getUsageMethod(optionList) {
      let usageMethod = _.cloneDeep(optionList)
 
      if(!this.isShowCafeteriaPoint){
        usageMethod = usageMethod.filter(
          function( item ) { return item.value !== "canUseCafeteriaPoint"; });
      }
      if(!this.isShowSupplementaryCoupon){
        usageMethod = usageMethod.filter(
          function( item ) { return item.value !== "canUseSubsidy"; });        
      }
      return usageMethod
    },  
    async checkAvailableCafeAndSubsidy() {
      // プラン毎のカフェ・補助金検索が動いていない為、
      // メニュー詳細のプラン一覧について、一時的にコメントアウト
      // const cafe = await this.$repositories('cafe').checkCafeAvailable();
      // const avaialbleCafe = cafe.data;

      // if (avaialbleCafe && avaialbleCafe === 'OK') {
      //   this.isShowCafeteriaPoint = true;
      // }

      // const availableDataList = await this.$repositories("coupon").getSubsidyCouponList({displayDiv: "1"});
      // if (availableDataList && availableDataList.length > 0) {
      //   this.isShowSupplementaryCoupon = true;
      // }
    },
  },
  // updated() {
  //   this.searchPlan()
  // },
  mounted() {
    console.log("mounted")
    this.checkAvailableCafeAndSubsidy();
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
